import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { key: { type: String, default: 'banner-dismissed' } }

  get dismissed () {
    return window.sessionStorage.getItem(this.keyValue) === 'true'
  }

  connect () {
    if (this.dismissed) {
      this.element.remove()
      return
    }

    this.element.classList.remove('hidden')
  }

  dismiss () {
    window.sessionStorage.setItem(this.keyValue, 'true')
    this.element.remove()
  }
}
